import { useMutationWithRefresh } from '../useMutationWithRefresh';
import siteService from '../../services/siteService';
import { queryKeys } from '../../queryClient';

// สร้างโครงการ
export const useCreateSite = () => {
  return useMutationWithRefresh({
    mutationFn: (data: any) => siteService.createSite(data),
    invalidateKeys: [
      queryKeys.sites.all,
      queryKeys.rentals.all, // rentals อาจแสดง dropdown โครงการ
      queryKeys.customers.all, // customers อาจแสดงโครงการ
    ],
    successMessage: 'สร้างโครงการสำเร็จ',
  });
};

// แก้ไขโครงการ
export const useUpdateSite = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data, ifMatch }: { id: number; data: any; ifMatch?: string }) =>
      siteService.updateSite(id, data, ifMatch),
    invalidateKeys: [
      queryKeys.sites.all,
      queryKeys.rentals.all, // rentals แสดงชื่อโครงการ
      queryKeys.customers.all,
      queryKeys.contracts.all, // contracts อ้างอิงโครงการ
    ],
    successMessage: 'แก้ไขโครงการสำเร็จ',
    // 409 SITE_HAS_ACTIVE_USAGE = ขอให้ยืนยันปิดโครงการ — SitePage เปิดกล่องยืนยันเอง ไม่ใช่ข้อผิดพลาด
    isHandledError: (error: any) => {
      const envelope = error?.response?.data?.error;
      return error?.response?.status === 409 &&
        (envelope?.details?.reason ?? envelope?.reason) === 'SITE_HAS_ACTIVE_USAGE';
    },
  });
};

// ลบโครงการ
export const useDeleteSite = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => siteService.deleteSite(id),
    invalidateKeys: [
      queryKeys.sites.all,
      queryKeys.dashboard.summary, // dashboard อาจแสดงจำนวนโครงการ
    ],
    successMessage: 'ลบโครงการสำเร็จ',
  });
};